import { darkColors, lightColors } from "../../theme/colors";
import { PulseXToggleTheme } from "./types";

export const light: PulseXToggleTheme = {
  handleBackground: lightColors.backgroundAlt,
  handleShadow: lightColors.textDisabled,
};

export const dark: PulseXToggleTheme = {
  handleBackground: darkColors.backgroundAlt,
  handleShadow: darkColors.textDisabled,
};
